import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const updateErrorHandling = async ({ has_app_error, app_error_message, app_error_code, tsid, tag }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  try {
    const response = await axios.get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateErrorHandling&has_app_error=${has_app_error}&app_error_code=${app_error_code}&app_error_message=${app_error_message}&tsid=${tsid}&tag=${tag}`,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error fetching status message", error);
  }
};

const useUpdateErrorHandlingMutation = (options = {}) => {
  return useMutation({
    mutationFn: updateErrorHandling,
    ...options,
  });
};

export default useUpdateErrorHandlingMutation;